export class AlphaChannelService {

    public change(color: string, alpha: number = 1): string {
        if (this.isRgb(color)) {
            return this.changeAlphaInRgb(color, alpha);
        }

        if (this.isRgba(color)) {
            return this.changeAlphaInRgba(color, alpha);
        }

        if (this.isHex(color)) {
            return this.changeAlphaInHex(color, alpha);
        }

        return color;
    }

    private isRgba(color: string): boolean {
        const rgbaRegex = /rgba\(/;
        return rgbaRegex.test(color.toLowerCase());
    }

    private isRgb(color: string): boolean {
        const rgbRegex = /rgb\(/;
        return rgbRegex.test(color.toLowerCase());
    }

    private isHex(color: string): boolean {
        const hexRegex = /^#([a-fA-F0-9]{3}|[a-fA-F0-9]{6})$/;
        return hexRegex.test(color.toLowerCase());
    }

    private changeAlphaInRgb(rgb: string, alpha: number): string {
        return rgb.replace(/^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/, (match, r, g, b) => {
            return `rgba(${r}, ${g}, ${b}, ${alpha})`;
        });
    }

    private changeAlphaInRgba(rgba: string, alpha: number): string {
        return rgba.replace(/rgba\((\d+),\s*(\d+),\s*(\d+),\s*\d*\.?\d*\)/, (match, r, g, b) => {
            return `rgba(${r}, ${g}, ${b}, ${alpha})`;
        });
    }

    private changeAlphaInHex(hex: string, alpha: number): string {
        if (hex.length === 4) {
            hex = `#${hex[1]}${hex[1]}${hex[2]}${hex[2]}${hex[3]}${hex[3]}`;
        }

        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);

        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

}